export var PaymentFailedErrorResultCode;
(function(PaymentFailedErrorResultCode) {
    PaymentFailedErrorResultCode[/**
     * Indicates that the payment was accepted but the order was not successfully completed.
     * An order with a post-charge error cannot be completed.
     */ "OrderCompletionFailed"] = "OrderCompletionFailed";
    PaymentFailedErrorResultCode[/**
     * Indicates that an unexpected API error occurred.
     */ "ApiError"] = "ApiError";
    PaymentFailedErrorResultCode[/**
     * Indicates that an unexpected connector error occurred.
     */ "ConnectorError"] = "ConnectorError";
    PaymentFailedErrorResultCode[/**
     * Indicates that the payment was declined by the third-party payment provider.
     */ "PaymentDeclined"] = "PaymentDeclined";
})(PaymentFailedErrorResultCode || (PaymentFailedErrorResultCode = {}));

//# sourceMappingURL=payment-failed-error-result-code.js.map